import GLightbox from 'glightbox';

export class Lightbox {
  constructor() {
    const gallery = GLightbox({
      touchNavigation: true,
    })
  }
}
